<div class="container-fluid d-flex flex-column justify-content-center align-items-center">
    <img src="assets/chapps-logo.png"/>
    <mdb-card id="login-card" class="m-3">
        <mdb-card-body class="pb-2">

          <mdb-spinner *ngIf="isProccessing"></mdb-spinner>

          <div *ngIf="setPassword && !confirmSuccess && !alreadyConfirmed">

            <form #form="ngForm">
              <input type="password" id="passwordInput" name="passwordInput" class="form-control mb-2"
                     [(ngModel)]="password"
                     [placeholder]="Localization.Password | translate">
              <input type="password" id="confirmPasswordInput" name="confirmPasswordInput" class="form-control mb-2"
                     [(ngModel)]="confirmPassword"
                     [placeholder]="Localization.ConfirmPassword | translate">
            </form>

            <div *ngIf="!doesPasswordHaveTargetedLenght() && form.touched"
              class="alert alert-warning mb-0"
              role="alert"
              [translate]="Localization.BadPasswordLength"
              [translateParams]="{value: applicationConfig.MIN_PASSWORD_LENGTH}">
            </div>
            <div *ngIf="!areBothPasswordEqual() && doesPasswordHaveTargetedLenght()"
              class="alert alert-warning mb-0"
              role="alert"
              [translate]="Localization.PasswordsDoNotMatch">
            </div>
          </div>

          <div *ngIf="requiresPrivacyConsent && !confirmSuccess && !alreadyConfirmed" class="form-check mt-3 mb-2">
            <input type="checkbox" id="privacyConsent" name="privacyConsent" class="form-check-input"
                   [(ngModel)]="privacyConsentAccepted" required>
                 <label for="privacyConsent" class="form-check-label"
                   [innerHTML]="Localization.IHaveReadAndAgreeToThePrivacyPolicy | translate"></label>
          </div>

          <div *ngIf="confirmSuccess && !isProccessing"
            class="alert alert-success mb-0"
            role="alert"
            [translate]="Localization.AccountConfirmationSuccess">
          </div>
          <div *ngIf="alreadyConfirmed && !isProccessing"
            class="alert alert-warning mb-0"
            role="alert"
            [translate]="Localization.AccountAlreadyConfirmed">
          </div>
          <div *ngIf="confirmFailed && !isProccessing"
            class="alert alert-danger mb-0"
            role="alert"
            [translate]="Localization.AccountConfirmationFailed">
          </div>

        </mdb-card-body>
        <mdb-card-footer class="text-center">
            <button *ngIf="!isProccessing && (setPassword || requiresPrivacyConsent)" type="button" class="mb-2"
                  mdbBtn
                  appBg="primary"
                  brightness="normal"
                  appTextColor="primary"
                  [block]="true"
                  (click)="confirmAccount()"
                  mdbWavesEffect
                  [disabled]="(setPassword && (!areBothPasswordEqual() || !doesPasswordHaveTargetedLenght())) || (requiresPrivacyConsent && !privacyConsentAccepted)"
                  [translate]="Localization.Submit">
            </button>
            <button type="button" class="mb-2"
                  mdbBtn
                  appBg="primary"
                  brightness="normal"
                  appTextColor="primary"
                  [block]="true"
                  (click)="goToLoginPage()"
                  [translate]="Localization.GoToLoginPage"></button>
        </mdb-card-footer>
    </mdb-card>
  </div>
